<template>
  <div class="status-page">
    <el-card class="status-card">
      <template #header>
        <div class="card-header">
          <h3>审核进度查询</h3>
          <el-tag size="large" :type="statusTagType(student?.review_status)">
            {{ statusText(student?.review_status || '未审核') }}
          </el-tag>
        </div>
      </template>

      <el-steps :active="currentStep" finish-status="success" process-status="process" simple class="status-steps">
        <el-step title="提交报名"></el-step>
        <el-step title="初审"></el-step>
        <el-step title="复审"></el-step>
        <el-step title="最终审核"></el-step>
      </el-steps>

      <el-descriptions v-if="student" :column="2" border class="detail-panel">
        <el-descriptions-item label="姓名">{{ student.name }}</el-descriptions-item>
        <el-descriptions-item label="性别">{{ student.gender || '-' }}</el-descriptions-item>
        <el-descriptions-item label="初中学校">{{ student.school || '-' }}</el-descriptions-item>
        <el-descriptions-item label="身份证件号">{{ student.id_card }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ student.phone }}</el-descriptions-item>
        <el-descriptions-item label="审核状态">
          <el-tag :type="statusTagType(student.review_status)">
            {{ statusText(student.review_status) }}
          </el-tag>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { enrollmentStudentApi } from '@/api'

const student = ref(null)

const statusText = (status) => {
  switch (status) {
    case '未审核': return '未审核'
    case '初审通过':
    case '操作一': return '初审通过'
    case '复审通过':
    case '操作二': return '复审通过'
    case '最终通过':
    case '操作三': return '最终通过'
    case '不通过': return '未通过'
    default: return status
  }
}

const statusTagType = (status) => {
  switch (status) {
    case '未审核': return 'info'
    case '初审通过':
    case '操作一': return 'primary'
    case '复审通过':
    case '操作二': return 'warning'
    case '最终通过':
    case '操作三': return 'success'
    case '不通过': return 'danger'
    default: return 'info'
  }
}

const currentStep = computed(() => {
  const status = student.value?.review_status
  if (status === '不通过') return 1
  if (status === '最终通过' || status === '操作三') return 3
  if (status === '复审通过' || status === '操作二') return 2
  if (status === '初审通过' || status === '操作一') return 1
  return 0
})

onMounted(async () => {
  student.value = await enrollmentStudentApi.getForm()
})
</script>

<style scoped>
.status-page {
  max-width: 1100px;
}

.status-card {
  border-radius: 18px;
  border: 1px solid rgba(191, 219, 254, 0.65);
  box-shadow: 0 16px 36px rgba(30, 64, 175, 0.08);
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-header h3 {
  color: #0b3a73;
  font-size: 20px;
}

.status-steps {
  margin-bottom: 16px;
  background: linear-gradient(90deg, rgba(239, 246, 255, 0.9), rgba(240, 249, 255, 0.7));
  border: 1px solid #dbeafe;
  border-radius: 10px;
  padding: 6px 10px;
}

.detail-panel {
  margin-top: 12px;
}

@media (max-width: 768px) {
  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
</style>
